import { useHistory, useLocation } from 'react-router-dom'
import placeholder from '../../assets/images/img-placeholder.jpg'
import { Box, ButtonBase, Card, Divider, Fade, Typography } from '@mui/material'
import { FaArrowLeft, FaPercent } from 'react-icons/fa'
import LogoNevula from '../../assets/images/logo-only-blue.svg'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import Button from '../../components/General/Button'
import { IoCashSharp } from 'react-icons/io5'
import { useEffect, useMemo, useRef, useState } from 'react'
import { Modal as ModalUI } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import { CashForm } from '../components/sales/CashForm'
import { CardForm } from '../components/sales/CardForm'
import ZellePaymentForm from '../components/sales/ZelleForm'
import RawAutoComplete from '../../components/Inputs/RawAutoComplete'
import axios from 'axios'
import { MdOutlineCancel, MdOutlineFileCopy } from 'react-icons/md'
import CurrencyInput from 'react-currency-input-field'
import { dateToDB, formatPipe, getDenomination, getIvaNumber } from '../../utils/utils'
import { toFixed } from 'accounting'
import { IGlobalRate } from '../../views/Sells/Sells'
import { DateTime } from 'luxon'
import { useDispatch, useSelector } from 'react-redux'
import { fetchRates } from '../../redux/actions/rates'
import { RootState } from '../../redux/store'
import IMask from 'imask'
import Switch from '../../components/Inputs/Switch'
import { IconType } from 'react-icons'
import { IGTFForm } from '../components/sales/IGTFForm'
import { fectchAccounts } from '../../redux/actions/accounts'
import { TransferPaymentForm } from '../components/sales/TransferForm'
import MobilePaymentForm from '../components/sales/MobilePayment'
import OnlinePaymentForm from '../components/sales/OnlinePaymentForm'
import useSnackBars from '../../hooks/SnackbarConsumerHook'
import { IMoneyAccount } from 'safe'
// import CurrencyInput from '../../components/Inputs/CurrencyInput'
import { toDataURL } from "qrcode";
import Tooltip from '../../components/Display/Tooltip'

const server = process.env.REACT_APP_SERVER_URL

enum accountTypeEnum {
  CASH = 'CASH',
  BANKACCOUNT = 'BANK ACCOUNT',
  WALLET = 'WALLET',
  CARD = 'CARD',
  mobilePayment = 'mobilePayment',
  nationalTransfer = 'nationalTransfer',
  CREDIT = 'CREDIT',
  IGTF = 'IGTF',
  C2P = 'C2P',
  ZELLE = 'ZELLE',
  PAGO_MOVIL = 'PAGO_MOVIL',
}

export const SaleGenerateView = () => {

  const [qrCode, setQrcode] = useState<string>('')


  const bottomRef = useRef<any>()

  const screenRef = useRef<any>()

  const location = useLocation()
  const today = DateTime.local().setLocale('es')

  const data = location.state as any

  const [typeForm, setTypeForm] = useState<string | null>(null)

  const [discountValue, setDiscountValue] = useState<number>(0)

  const { addAlert } = useSnackBars()

  const history = useHistory()

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #ffff',
    boxShadow: 24,
    p: 4,
  }

  const [step, setStep] = useState<number>(0)

  const [selectedItem, setSelectedItem] = useState<any>(null)

  const [warehouses, setWarehouses] = useState<any[]>([])

  const [items, setItems] = useState<any[]>([])

  const [globalRate, setGlobalRate] = useState<IGlobalRate[]>([])

  const dispatch = useDispatch()

  const globalRateRedux = useSelector((state: RootState) => state?.rates.rates)

  const discountRef = useRef<any>(null)

  const [igtfAmount, setIgtfAmount] = useState<number>(0)

  const [disableDiscount, setDisableDiscount] = useState<boolean>(false)

  const [height, setHeight] = useState<number>(0)

  const [isIGTFActive, setIsIGTFActive] = useState<boolean>(false)

  const [selectedMethods, setSelectedMethods] = useState<any>([])

  const accounts = useSelector((state: RootState) => state.acct.accounts)

  const [amountC2p, setAmountC2p] = useState<string>('0')

  // const [selectedMethod, setSelectedMethod] = useState<IMethods | null>(null)

  const [tokenClient, setTokenClient] = useState<null | any>(null)

  const [saleDate, setSaleDate] = useState<string>(DateTime.local().setLocale('es').toFormat("d/M/yyyy"))

  const [paymentId, setPaymentId] = useState<string | null>(null)

  const [c2pMode, setC2pMode] = useState<boolean>(false)

  // const [isCashOut, setIsCashOut] = useState<boolean>(true)

  const [seconds, setSeconds] = useState(5 * 60);

  const getWarehouses = async () => {
    const resWarehouses = await axios.get(`${server}/inventory/warehouse`)
    setWarehouses(resWarehouses.data.warehouses)
  }

  useEffect(() => {
    getWarehouses()
  }, [])

  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;

    return `0${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  async function initializeGapiClient() {
    //@ts-ignore
    await gapi?.client?.init({
      apiKey: process.env.REACT_APP_GOOGLE_API_KEY,
      discoveryDocs: [
        'https://www.googleapis.com/discovery/v1/apis/gmail/v1/rest',
      ],
    })
  }

  function gisLoaded() {
    //@ts-ignore
    let tokenClient = google?.accounts?.oauth2?.initTokenClient({
      client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
      scope: 'https://www.googleapis.com/auth/gmail.readonly',
      callback: '', // defined later
    })
    console.log('token', tokenClient)
    setTokenClient(tokenClient)
  }

  useEffect(() => {
    //@ts-ignore
    gapi.load('client', initializeGapiClient)
    gisLoaded()
  }, [])

  const warehouseId = warehouses[0]?.id

  console.log('ITEMS', items)

  const onGetRate = (idCurrency: string | undefined): string => {
    // console.log("globalRate...", globalRate)
    return globalRate.find((rate) => rate.id === idCurrency)?.rate || '1'
  }

  const getRate = async (
    date = today.toISODate(),
    fromRedux = true
  ): Promise<void> => {
    if (fromRedux) {
      const today = DateTime.local().setLocale('es')
      // let date = today.toISODate()
      dispatch(fetchRates([`date=${date}`, `currency=${'all'}`]))
      // let response = await axios.get<{ rates: IGlobalRate[] }>(
      //   `${server}/finances/rate?date=${date}&currency=all`
      // )
      // console.log('response...', response)
      // setGlobalRate(response.data.rates)
    } else {
      let response = await axios.get(
        `${server}/finances/rate?date=${date}&currency=${'all'}`
      )
      setGlobalRate(response.data.rates)
      // if (!isFirstRender) {
      //   setModalRate(response?.data?.rates?.find(rate => rate?.id === "1")?.rate)
      // }
      // setIsFirstRender(false)
    }
  }

  const sumOfValues = (prop: string): number => {
    return items?.reduce(
      (a, b) => {
        // a['iva'] += b.exempt
        //   ? 0
        //   : +((+b?.price / getIvaNumber(b?.ivaType) ) * (tax / 100)) *
        //     +b?.amount
        // a['iva'] += b.ivaType === 'EXEMPT' ? +b.price : (+b.price * + ((getIvaNumber(b?.ivaType) + "").replace(/\d\./, ""))/100)
        a['iva'] =
          b.ivaType === 'EXEMPT'
            ? a['iva']
            : // :  (+b.price *
              //     +b.amount *
              //     +onGetRate(b.currency.id) *
              //     +(getIvaNumber(b?.ivaType) + '').replace(/\d\./, '') ) /
              //   100
              +a['iva'] +
              +toFixed(+b.price * +b.amount * +onGetRate(b?.currency?.id), 2) *
                +toFixed(
                  +(getIvaNumber(b?.ivaType) + '').replace(/\d\./, '') / 100,
                  2
                )
        a['exempt'] +=
          b.ivaType === 'EXEMPT'
            ? +toFixed(+b.price * +b.amount * +onGetRate(b?.currency?.id), 2)
            : 0
        // a['sub_total'] += !b.exempt
        //   ? +(
        //       (+b?.price / getIvaNumber(b?.ivaType)) *
        //       +b.amount
        //     ).toFixed(2)
        //   : 0
        a['sub_total'] =
          b.currency.id === '2'
            ? +toFixed(a['sub_total'] + +b?.price * +b?.amount, 2)
            : +toFixed(
                a['sub_total'] +
                  +b.price * +b.amount * +onGetRate(b.currency.id),
                2
              )
        a['total'] = +toFixed(+a['total'] + +b.price * +b.amount, 2)
        return a
      },
      { iva: 0, exempt: 0, total: 0, sub_total: 0 - discountValue }
    )[prop]
  }

  const getTotalAmount = () =>
    +toFixed(sumOfValues('sub_total'), 2) +
    +toFixed(sumOfValues('iva'), 2) +
    // +toFixed(sumOfValues('exempt'), 2) +
    +toFixed(igtfAmount, 2)

  useEffect(() => {
    getRate()
  }, [])

  const onGetDebt = (): string => {
    return toFixed(
      +toFixed(getTotalAmount(), 2) -
        +toFixed(
          +selectedMethods.reduce((a, b) => a + +b.amount * +b?.rate, 0),
          2
        ),
      2
    )
  }

  const debt = useMemo(() => onGetDebt(), [
    selectedMethods,
    items,
    igtfAmount,
    // saleDate,
  ])

  useEffect(() => {
    if (globalRateRedux.length) {
      setGlobalRate(globalRateRedux)
    }
  }, [globalRateRedux])

  useEffect(() => {
    let numberMask = IMask(discountRef.current, {
      mask: Number,
      thousandsSeparator: '.',
      radix: ',',
      scale: 2,
      normalizeZeros: true,
      padFractionalZeros: true,
      signed: false,
      max: 10000000000000,
    })
    numberMask.on('accept', () => {
      setDiscountValue(+numberMask.unmaskedValue)
    })
  }, [])

  useEffect(() => {
    if (bottomRef && screenRef) {
      setHeight(
        (screenRef?.current?.clientHeight - bottomRef?.current?.clientHeight) /
          2
      )
    }
  }, [bottomRef, screenRef])

  useEffect(() => {
    dispatch(fectchAccounts())
  }, [])


  useEffect(() => {
    if (c2pMode) {
      const interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          updateValidated().then(res => {
            clearInterval(interval);
            setC2pMode(false)
          }).catch(err => {
            addAlert({
              message: 'Error al actualizar el pago',
              status: 'error',
            })
          })
        }
      }, 1000);
  
      return () => {
        clearInterval(interval);
      };
    }
  }, [c2pMode, seconds]);

  useEffect(() => {
    if (!c2pMode) {
      setSeconds(5 * 60)
    }
  }, [c2pMode])

  const checkPayment = async () => {
    const[response, response1] = await Promise.all([axios.get(`${server}/user-payment?id=${paymentId}`), axios.get(`${server}/config/tenant`)])
    // let response = await axios.get(`${server}/user-payment?id=${paymentId}`)
    if (response?.data?.payment?.validated) {
      addAlert({
        message: 'Pago realizado satisfactoriamente',
        status: 'success',
      })
      setC2pMode(false)

      const today = DateTime.local().setLocale('es')

      let date = today.toISODate()
      
      let newPayment = {
      amount: amountC2p,
      reference: response?.data?.payment?.ref || "",
      currency: {
        id: '2',
      },
      account: {
        id: response1?.data?.userConf?.c2pAccountId,
      },
      date,
      type: 'C2P',
      rate: '1',
    }

    setSelectedMethods((prevState) => [...prevState, newPayment])

    }
  }

  useEffect(() => {
    if (c2pMode) {
      const interval = setInterval(() => {
        checkPayment()
      }, 5000);
  
      return () => {
        clearInterval(interval);
      };
    }
  }, [c2pMode])

  const updateValidated = async () => {
    try {
      let response = await axios.patch(`${server}/user-payment?id=${paymentId}`, {id: paymentId, cancelled: true})
    } catch (err) {
      throw err
    }
  }

  const onSelectMethod = async (
    method: any,
    type: accountTypeEnum
  ): Promise<void> => {
    console.log("TYPE", type)
    setTypeForm(null)

    let obj = {
      [accountTypeEnum.BANKACCOUNT]: 'Cuenta Bancaria',
      [accountTypeEnum.CARD]: 'Punto de venta',
      [accountTypeEnum.CASH]: 'Efectivo',
      [accountTypeEnum.WALLET]: 'Internacional/Otros',
      [accountTypeEnum.mobilePayment]: 'Pago Móvil',
      [accountTypeEnum.nationalTransfer]: 'Cuenta Bancaria',
      [accountTypeEnum.CREDIT]: 'Crédito',
      [accountTypeEnum.C2P]: 'C2P',
      [accountTypeEnum.ZELLE]: 'Zelle',
      [accountTypeEnum.PAGO_MOVIL]: 'Pago Móvil',
    }

    const today = DateTime.local().setLocale('es')

    let date = today.toISODate()

    if (type === accountTypeEnum.PAGO_MOVIL) {
      let configResponse = await axios.get(`${server}/config/tenant`)

      if (!configResponse.data.userConf.pmAccountId) {
        addAlert({
          message: 'Debe de agregar su cuenta de pago movil de destino',
          status: 'error',
        })
        return
      }

      if (!configResponse.data.userConf.pmClientId) {
        addAlert({
          message: 'Debe de agregar el rif de destino.',
          status: 'error',
        })
        return
      }

      if (method?.isManual) {
        let newPayment = {
          amount: method.amount,
          reference: method?.ref,
          currency: {
            id: '2',
          },
          account: {
            id: configResponse?.data?.userConf?.pmAccountId,
          },
          date,
          type: obj[type],
          rate: '1',
        }

        setSelectedMethods((prevState) => [...prevState, newPayment])

        return
      }

      try {
        if (!configResponse.data.userConf.pmAccountId) {
          addAlert({
            message: 'Debe de agregar su cuenta de pago movil de destino',
            status: 'error',
          })
          return
        }

        if (!configResponse.data.userConf.pmClientId) {
          addAlert({
            message: 'Debe de agregar el rif de destino.',
            status: 'error',
          })
          return
        }

        const { isManual, ...rest } = method

        let body = {
          ...rest,
          originNumber: +method?.originNumber.slice(1),
          destinyIdentification: configResponse.data.userConf.pmClientId,
        }

        let resp = await axios.post(`${server}/user-payment/validate-pm`, body)

        if (!resp.data.valid) {
          addAlert({ message: 'Pago no es válido', status: 'error' })
          return
        }

        let newPayment = {
          amount: method.amount,
          reference: method?.ref,
          currency: {
            id: '2',
          },
          account: {
            id: configResponse?.data?.userConf?.pmAccountId,
          },
          date,
          type: obj[type],
          rate: '1',
        }

        setSelectedMethods((prevState) => [...prevState, newPayment])
        addAlert({
          message: 'Pago móvil realizado satisfactoriamente',
          status: 'success',
        })
      } catch (err) {
        addAlert({
          message: 'No se pudo realizar el pago movil',
          status: 'error',
        })
      }
      return
    }

    if (type === accountTypeEnum.CARD) {
      let response = await axios.get(`${server}/cashier`)
      let idAccount = response?.data?.cashiers[0]?.idPosAccount
      if (!idAccount) {
        addAlert({
          message: 'No hay ninguna cuenta asociada a este cajero',
          status: 'error',
        })
        return
      }
      let newPayment = {
        amount: method.amount,
        reference: method.reference,
        currency: {
          id: '2',
        },
        /** Aqui tengo que colocar la cuenta de debito por defecto */
        account: {
          id: idAccount || '1',
        },
        date,
        type: obj[type],
        rate: '1',
      }
      // let isHigher = checkDebt([...selectedMethods, newPayment])
      // setIsHigherState(isHigher)
      setSelectedMethods((prevState) => [...prevState, newPayment])

      return
    }

    if (type === accountTypeEnum.C2P) {
      let configResponse = await axios.get(`${server}/config/tenant`)

      if (!configResponse?.data?.userConf?.c2pAccountId) {
        addAlert({
          message: 'Debe de tener una cuenta asociada a c2p.',
          status: 'error',
        })
        return
      }

      if (!configResponse?.data?.userConf?.c2pClientId) {
        addAlert({
          message: 'Debe de tener un Rif/CI la cuenta asociada.',
          status: 'error',
        })
        return
      }

      let userTenant = await axios.get(`${server}/user/tenant`)
      let body = {
        amount: method?.amount,
        sale: {
          businessSocial: userTenant?.data?.tenant?.businessSocial,
        },
        // sale: {
        //   total: method?.amount,
        //   items: []
        // }
      }

      setAmountC2p(method?.amount)

      const response = await axios.post(`${server}/user-payment`, body)

      let qrCode = await toDataURL(
        `${window.location.origin}/pago_en_linea?id=${response.data?.payment?.id}`
      );

      setQrcode(qrCode)

      setPaymentId(response.data?.payment?.id)

      setC2pMode(true)
      return
    }

    if (type === accountTypeEnum.ZELLE) {
      if (method?.isManual) {
        const tenantInfo = await axios.get(`${server}/config/tenant`)
        let newPayment = {
          amount: method.amount,
          reference: '',
          currency: {
            id: '1',
          },
          account: {
            id: tenantInfo?.data?.userConf?.zelleAccountId,
          },
          date,
          type: obj[type],
          rate: '1',
        }

        // newPayment.amount = +newPayment.rate * +newPayment?.amount || newPayment?.amount

        // if (account.idCurrency !== '2') {
        //   axios.get(`${server}/finances/rate?date=${date}&`)
        // }

        let rate = onGetRate('1')
        // console.log('rate...', rate)
        // let rate = globalRate.find(rate => rate.id === account.idCurrency)

        newPayment.rate = rate || newPayment.rate

        // console.group('new payment', newPayment)

        // let isHigher = checkDebt([...selectedMethods, newPayment])
        // setIsHigherState(isHigher)

        setSelectedMethods((prevState) => [...prevState, newPayment])

        return
      }

      addAlert({
        message: 'Validando Pago...',
        status: 'loading',
      })
      //Oauth
      if (tokenClient) {
        tokenClient.callback = async (resp) => {
          //@ts-ignore
          const token = gapi.client.getToken()
          let body = {
            name: method?.name?.split(' ')[0],
            amount: method?.amount.toFixed(2),
            token: token?.access_token,
          }
          try {
            // await axios.patch(`${server}/config/tenant`
            // await axios.post(`${server}/validate-zelle`, body)

            const [tenantInfo, zelleResponse] = await Promise.all([
              axios.get(`${server}/config/tenant`),
              axios.post(`${server}/validate-zelle`, body),
            ])

            if (!zelleResponse.data?.valid) {
              addAlert({ message: 'Zelle no es válido', status: 'error' })
              return
            }

            addAlert({
              message: 'Pago realizado satisfactoriamente',
              status: 'success',
            })

            // let account = accounts.find(
            //   (account) => account.id === method.type
            // ) as IMoneyAccount

            let newPayment = {
              amount: method.amount,
              reference: '',
              currency: {
                id: '1',
              },
              account: {
                id: tenantInfo?.data?.userConf?.zelleAccountId,
              },
              date,
              type: obj[type],
              rate: '1',
            }

            // newPayment.amount = +newPayment.rate * +newPayment?.amount || newPayment?.amount

            // if (account.idCurrency !== '2') {
            //   axios.get(`${server}/finances/rate?date=${date}&`)
            // }

            let rate = onGetRate('1')
            // console.log('rate...', rate)
            // let rate = globalRate.find(rate => rate.id === account.idCurrency)

            newPayment.rate = rate || newPayment.rate

            // console.group('new payment', newPayment)

            // let isHigher = checkDebt([...selectedMethods, newPayment])
            // setIsHigherState(isHigher)

            setSelectedMethods((prevState) => [...prevState, newPayment])
          } catch (err) {
            addAlert({
              message: 'No se pudo validar el zelle',
              status: 'error',
            })
          }

          if (resp.error !== undefined) {
            throw resp
          }
        }

        //@ts-ignore
        if (gapi.client.getToken() === null) {
          // Prompt the user to select a Google Account and ask for consent to share their data
          // when establishing a new session.
          tokenClient.requestAccessToken({ prompt: 'consent' })
        } else {
          //@ts-ignore
          console.log('client', gapi.client)
          // Skip display of account chooser and consent dialog for an existing session.
          tokenClient.requestAccessToken({ prompt: '' })
        }
      }
      return
    }

    let account = accounts.find(
      (account) => account.id === method.type
    ) as IMoneyAccount

    let newPayment = {
      amount: method.amount,
      reference: method.reference,
      currency: {
        id: account.idCurrency,
      },
      account: {
        id: method.type,
      },
      date,
      type: obj[type],
      rate: '1',
    }

    let rate = onGetRate(account.idCurrency)
    console.log('rate...', rate)
    // let rate = globalRate.find(rate => rate.id === account.idCurrency)

    newPayment.rate = rate || newPayment.rate

    // newPayment.amount = +newPayment.rate * +newPayment?.amount || newPayment?.amount

    // if (account.idCurrency !== '2') {
    //   axios.get(`${server}/finances/rate?date=${date}&`)
    // }

    // console.group('new payment', newPayment)

    // let isHigher = checkDebt([...selectedMethods, newPayment])
    // setIsHigherState(isHigher)

    setSelectedMethods((prevState) => [...prevState, newPayment])

    // if (account && method.ref) {
    //   console.log('IF', method)
    //   console.log('tyoe', type)
    //   setSelectedMethods((prevState) => [
    //     ...prevState,
    //     {
    //       ...account,
    //       id: method.type,
    //       amount: method.amount,
    //       type: obj[type],
    //       ref: method.ref,
    //       paymentStatus: TypeStatus.UNDONE,
    //       bills,
    //     },
    //   ])
    // } else {
    //   setSelectedMethods((prevState) => [
    //     ...prevState,
    //     {
    //       ...account,
    //       id: method.type,
    //       amount: method.amount,
    //       type: obj[type],
    //       paymentStatus: TypeStatus.UNDONE,
    //       bills,
    //     },
    //   ])
    // }
  }

  const checkDebt = () => {

    let amount = selectedMethods.reduce((a, b) => {
      // console.log("amount", b)
      if (b?.currency?.id === "1") {
        return a + +b?.amount
      }
      return a
    }, 0)

    return (amount === +toFixed(
      getTotalAmount() / +onGetRate('1'), 2)) && +debt <= 0.15

  }

  const onCreateSell = async (): Promise<void> => {
    let isHigher = checkDebt()
    // setIsHigherState(isHigher)
    // console.log("HIGHER", isHigher)

    if (+debt > 0 && !isHigher) {
      addAlert({ message: 'El monto de pago debe de ser mayor o igual al monto de venta', status: 'error' })
      return
    }

    let services = items?.filter(service => !service?.category?.id)

    let newItems = items?.filter(item => item?.category?.id)

    let paymentMethodType = {
      'Billetera Virtual': 'WALLET',
      'Cuenta Bancaria': 'TRANSFERENCE',
      Efectivo: 'CASH',
      'Punto de venta': 'CARD',
      'Pago Móvil': 'MOBILE PAYMENT',
      Crédito: 'CREDIT',
    }

    console.log('selected methods', selectedMethods)

    const today = DateTime.local().setLocale('es')

    console.log('selected methods...', selectedMethods)

    /** Ya que en este plan de momento solo se tendrá un almacen  */
    let warehouse = warehouses[0]?.id

    let objBody = {}

    // if (
    //   credit?.finalDate &&
    //   credit.installmentQuantity &&
    //   credit.installmentRange &&
    //   credit.startDate
    // ) {

    //   if (services?.length && items?.length) {
    //     objBody = {
    //       saleClient: {
    //         id: selectedClient?.id,
    //       },
    //       warehouse: {
    //         id: warehouse,
    //       },
    //       paidOut: false,
    //       description: 'Una venta',
    //       total: toFixed(getTotalAmount(), 2),
    //       // total: getTotalAmount().toFixed(2),
    //       discount: discountValue + '',
    //       iva: toFixed(sumOfValues('iva'), 2),
    //       // iva: sumOfValues('iva').toFixed(2),
    //       igtf: toFixed(igtfAmount, 2),
    //       // igtf: igtfAmount.toFixed(2),
    //       date: dateToDB(saleDate),
    //       exchangeDifference: isHigher ? +debt : undefined,
    //       // date: today.toISODate(),
    //       currency: {
    //         id: '2',
    //       },
    //       items,
    //       services,
    //       credit: {
    //         ...credit,
    //         startDate: dateToDB(credit.startDate),
    //         finalDate: dateToDB(credit.finalDate),
    //       },
    //     }
    //   }

    //   if (services?.length) {
    //     objBody = {
    //       saleClient: {
    //         id: selectedClient?.id,
    //       },
    //       warehouse: {
    //         id: warehouse,
    //       },
    //       paidOut: false,
    //       description: 'Una venta',
    //       total: toFixed(getTotalAmount(), 2),
    //       // total: getTotalAmount().toFixed(2),
    //       discount: discountValue + '',
    //       iva: toFixed(sumOfValues('iva'), 2),
    //       // iva: sumOfValues('iva').toFixed(2),
    //       igtf: toFixed(igtfAmount, 2),
    //       // igtf: igtfAmount.toFixed(2),
    //       date: dateToDB(saleDate),
    //       exchangeDifference: isHigher ? +debt : undefined,
    //       currency: {
    //         id: '2',
    //       },
    //       services,
    //       credit: {
    //         ...credit,
    //         startDate: dateToDB(credit.startDate),
    //         finalDate: dateToDB(credit.finalDate),
    //       },
    //     }
    //   }

    //   if (items?.length) {
    //     objBody = {
    //       saleClient: {
    //         id: selectedClient?.id,
    //       },
    //       warehouse: {
    //         id: warehouse,
    //       },
    //       paidOut: false,
    //       description: 'Una venta',
    //       total: toFixed(getTotalAmount(), 2),
    //       // total: getTotalAmount().toFixed(2),
    //       discount: discountValue + '',
    //       iva: toFixed(sumOfValues('iva'), 2),
    //       // iva: sumOfValues('iva').toFixed(2),
    //       igtf: toFixed(igtfAmount, 2),
    //       // igtf: igtfAmount.toFixed(2),
    //       date: dateToDB(saleDate),
    //       exchangeDifference: isHigher ? +debt : undefined,
    //       currency: {
    //         id: '2',
    //       },
    //       items,
    //       credit: {
    //         ...credit,
    //         startDate: dateToDB(credit.startDate),
    //         finalDate: dateToDB(credit.finalDate),
    //       },
    //     }
    //   }

    // } 
    if (+debt <= 0 || isHigher) {

      if (items?.length && services?.length) {
        objBody = {
          saleClient: {
            id: data?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          items: newItems,
          services
        }
      }

      if (items?.length) {
        objBody = {
          saleClient: {
            id: data?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          items: newItems,
        }
      }

      if (services?.length) {
        objBody = {
          saleClient: {
            id: data?.id,
          },
          warehouse: {
            id: warehouse,
          },
          paidOut: true,
          description: 'Una venta',
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          discount: discountValue + '',
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          date: dateToDB(saleDate),
          exchangeDifference: isHigher ? +debt : undefined,
          payments: selectedMethods.map((v) => {
            const { type, ...rest } = v
            return rest
          }),
          currency: {
            id: '2',
          },
          services,
        }
      }
    }

    // if (+debt < 0) {
    //   // addAlert({
    //   //   message: 'El total ingresado debe de ser mayor o igual a la deuda',
    //   //   status: 'error',
    //   // })
    //   // return
    //   setShowAdvancedPayable(true)
    //   return
    // }

    try {
      addAlert({ message: 'Creando venta...', status: 'loading' })
      let userResponse = await axios.get(`${server}/user/tenant`)
      let configResponse = await axios.get(`${server}/config/tenant`)
      //Respuesta que se usará para el codigo
      let response = await axios.post(`${server}/sale`, objBody)

      let date = dateToDB(saleDate)

      const [year, month, day] = date.split('-');

      if (data?.email) {
        let emailBody = {
          invoiceCode: response?.data?.invoice?.code,
          nevulaUser: {
            businessName: userResponse?.data?.tenant?.businessSocial,
          },
          client: {
            name: data?.name,
            document: `${data?.documentType}-${data?.document}`,
            email: data?.email,
          },
          // subTotal: sumOfValues('sub_total').toFixed(2),
          subTotal: toFixed(sumOfValues('sub_total'), 2),
          // iva: sumOfValues('iva').toFixed(2),
          iva: toFixed(sumOfValues('iva'), 2),
          discount: discountValue + '',
          // igtf: igtfAmount.toFixed(2),
          igtf: toFixed(igtfAmount, 2),
          // total: getTotalAmount().toFixed(2),
          total: toFixed(getTotalAmount(), 2),
          date: `${day}/${month}/${year}`,
          userMessage: configResponse?.data?.userConf?.saleEmailMessage,
          logoURL: userResponse.data.tenant.image,
          // 'https://i.pinimg.com/736x/ec/7c/af/ec7cafae1224c318796d41e728eacb6d.jpg',
          items: items?.map((item) => ({
            quantity: item.amount,
            description: item.name,
            unitPrice: item.price,
            totalPrice: +item?.amount * +item?.price,
          })),
        }
        let responseEmail = await axios.post(`${server}/sale/email`, emailBody)
      }

      // setInvoiceNumber(response?.data?.invoice?.code)
      // setShowPdf(true)
      addAlert({
        message: 'Venta creada satisfactoriamente',
        status: 'success',
      })
      history?.push("/sales")
    } catch (err) {
      addAlert({ message: 'Error al crear la venta', status: 'error' })
    }

    // axios.delete('www.se')

    // const objBody = {
    //   sale: {
    //     client: {
    //       id: selectedClient?.id,
    //     },
    //     payments: selectedMethods.map((method) => ({
    //       idAccount: method.id || '',
    //       amount: +method.amount,
    //       details: formatValueToSave(method)?.accountType,
    //       transactionType: method.type === 'Crédito' ? 'EXPENSES' : 'INCOME',
    //       receipt: method.ref || '',
    //       bills: method?.bills,
    //     })),
    //     unload: {
    //       destination: {
    //         id: '1',
    //         locationType: 'warehouse',
    //       },
    //       // items: selectedItems?.map((item) => ({
    //       //   idItem: item.id,
    //       //   amount: item.amount,
    //       // })),
    //       items: selectedItems?.reduce((a, b) => {
    //         a = [...a, { idItem: b.id, amount: b.amount }]
    //         if (b.type === 'COMPOUND' && b.compositionCompound) {
    //           a = [
    //             ...a,
    //             ...b.compositionCompound.map((v) => ({
    //               idItem: v.item.id,
    //               amount: b.amount,
    //             })),
    //           ]
    //         }
    //         return a
    //       }, [] as any),
    //     },
    //     invoice: {
    //       taxPrice: sumOfValues('iva').toFixed(2),
    //       tax: tax + '',
    //       taxBase: sumOfValues('sub_total').toFixed(2),
    //       subTotal:
    //         +sumOfValues('exempt').toFixed(2) +
    //         +sumOfValues('sub_total').toFixed(2),
    //       exempt: +sumOfValues('exempt').toFixed(2),
    //       total:
    //         +sumOfValues('sub_total').toFixed(2) +
    //         +sumOfValues('iva').toFixed(2) +
    //         +sumOfValues('exempt').toFixed(2),
    //       invoiceDetail: {
    //         invoiceNumber: '',
    //         items: selectedItems,
    //       },
    //     },
    //     deliveryNote: {},
    //     cashier: 'Gustavo Parra',
    //     seller: '1',
    //   },
    // }

    // let replaceValue = {
    //   á: 'a',
    //   é: 'é',
    //   í: 'i',
    //   ó: 'o',
    //   ú: 'u',
    // }

    // let objToInvoice = {
    //   invoice: {
    //     tax: '',
    //     tax_base: '',
    //     exempt: '',
    //     total: '',
    //     cashier: {
    //       seller: 'José Perez',
    //       safeBox: 'Caja 1',
    //     },
    //     client: {
    //       name: selectedClient?.name,
    //       surname: selectedClient?.surname,
    //       document: {
    //         document: selectedClient?.document,
    //         documentType: selectedClient?.documentType,
    //       },
    //       address: selectedClient?.address?.street,
    //       phone: selectedClient?.phones[0].number,
    //     },
    //     items: selectedItems?.map((item) => ({
    //       name: item.name.replace(/[áéíóú]/gi, (v) =>
    //         replaceValue[v.toLowerCase()].toUpperCase()
    //       ),
    //       amount: item.amount + '',
    //       price: !item.exempt
    //         ? (+item?.price[0]?.amount / Number(`1.${tax}`)).toFixed(2)
    //         : Number(item.price[0].amount).toFixed(2),
    //       exempt: item.exempt,
    //     })),
    //     payments: selectedMethods.map((method) => ({
    //       paymentMethod: paymentMethodType[method.type],
    //       amount: Number(method.amount).toFixed(2),
    //     })),
    //   },
    // }

    // let response = await axios.post('http://127.0.0.1:5000/api/factura', objToInvoice, config)

    // let debt = +(
    //   getTotalAmount() -
    //   +selectedMethods.reduce((a, b) => a + +b.amount, 0).toFixed(2)
    // ).toFixed(2)

    // let total_income = +selectedMethods
    //   .reduce((a, b) => a + +b.amount, 0)
    //   .toFixed(2)

    // if (debt === 0 && total_income === +getTotalAmount().toFixed(2)) {
    //   let headers = new Headers()
    //   headers.append('Content-Type', 'application/json')
    //   headers.append('Accept', 'application/json')

    //   addAlert({ message: 'Creando venta', status: 'loading' })
    //   fetch('http://127.0.0.1:5000/api/factura', {
    //     method: 'POST',
    //     mode: 'cors',
    //     body: JSON.stringify(objToInvoice),
    //     headers,
    //   })
    //     .then((v) => {
    //       return v.json()
    //     })
    //     .then(async (res) => {
    //       if (res?.Error) {
    //         addAlert({ message: res?.Error, status: 'error' })
    //         return
    //       }
    //       try {
    //         await axios.post(`${server}/business/sale/invoice`, {
    //           sale: {
    //             ...objBody.sale,
    //             invoice: {
    //               ...objBody.sale.invoice,
    //               invoiceDetail: {
    //                 ...objBody.sale.invoice.invoiceDetail,
    //                 invoiceNumber: res.invoice_number,
    //               },
    //             },
    //           },
    //         })
    //         setAlreadySelled(true)
    //         addAlert({ message: 'Venta creada con exito!', status: 'success' })
    //       } catch (err) {
    //         addAlert({ message: 'Error al crear una venta!', status: 'error' })
    //       }
    //     })
    //     .catch((err) => {
    //       addAlert({ message: 'Error con máquina fiscal', status: 'error' })
    //     })
    // } else {
    //   addAlert({
    //     message: 'El total ingresado es mayor a la deuda!',
    //     status: 'error',
    //   })
    // }
  }


  return (
    <div
      style={{ position: 'relative', height: 'calc(100vh - 72px)' }}
      ref={screenRef}
    >
      <div className="flex">
        <FaArrowLeft className="text-primary" />
      </div>

      <div className="flex flex-row justify-end">
        <div className="flex items-center">
          <IoCashSharp className="text-primary mr-2" />

          <label className="text-primary text-sm font-semibold">
            Tasa Bs/USD: 66,44
          </label>
        </div>
      </div>

      <div className="mt-3">
        <Card className="p-2">
          <div className="flex justify-between">
            <label className="text-sm text-gray-400">Nombre del cliente</label>
            <label className="text-sm text-gray-400">Documento legal</label>
          </div>

          <div className="flex justify-between">
            <label className="text-sm text-primary font-semibold">
              {data?.name}
            </label>
            <label className="text-sm text-gray-400">{`${data?.documentType}-${data?.document}`}</label>
          </div>

          <div>
            <label className="text-sm text-gray-400">14/3/2025</label>
          </div>
        </Card>
      </div>

      <div className="mt-3">
        {step === 0 && (
          <>
            <div className="flex justify-between items-center">
              <div className="w-[80%]">
                {/* <InputText
                placeholder="Productos o servicios..."
                onChangeValue={() => {}}
              /> */}

                {warehouseId && (
                  <RawAutoComplete
                    label="Artículo"
                    url={`inventory/existence`}
                    bodyGet={'items'}
                    queryParam={'fastSearch'}
                    selectedValue={selectedItem}
                    setSelectedValue={(value) => {
                      setSelectedItem(value)
                      setItems((prevState) => [
                        ...prevState,
                        { ...value, amount: 1 },
                      ])
                    }}
                    outsideParams={[
                      `id=${warehouseId}`,
                      `sale=true`,
                      `pageNumber=${1}`,
                      `pageSize=${10}`,
                    ]}
                    placeholder="Producto o servicio..."
                  />
                )}
              </div>

              <IoCashSharp className="text-primary mr-2" size={35} />
            </div>

            <div
              className="mt-5"
              style={{ height, overflow: 'auto', overflowX: 'hidden' }}
            >
              {items?.map((x, idx) => (
                <div className="flex flex-row justify-between items-center mb-3">
                  <div style={{ width: '15%' }}>
                    <CurrencyInput
                      id="input-example"
                      decimalSeparator=","
                      groupSeparator="."
                      decimalsLimit={2}
                      defaultValue={1}
                      // value={x.amount + ""}
                      onValueChange={(value, _, values) => {
                        let selected = [...items]

                        selected[idx].amount =
                          value === '0' ? '1' : values?.float + ''
                        setItems(selected)
                      }}
                    />
                    {/* <label>{x?.amount}</label> */}
                  </div>

                  <div style={{ width: '40%' }} className="flex flex-col">
                    <div>
                      <label className="text-sm">{x?.name}</label>
                    </div>

                    <div>
                      <label className="text-xs text-gray-700">{x?.sku}</label>
                    </div>
                  </div>

                  <div style={{ width: '30%' }} className="flex flex-col">
                    <div>
                      <label>{`Bs. ${formatPipe(
                        toFixed(
                          +x.price * +x?.amount * +onGetRate(x?.currency?.id),
                          2
                        )
                      )}`}</label>
                    </div>

                    <div>
                      <label>
                        {' '}
                        {`Bs. ${
                          x?.ivaType === 'EXEMPT'
                            ? '0.00'
                            : formatPipe(
                                // (
                                //   (+item.price *
                                //     +item.amount *
                                //     +onGetRate(item.currency.id) *
                                //     +(
                                //       getIvaNumber(item?.ivaType) + ''
                                //     ).replace(/\d\./, '')) /
                                //   100
                                // ).toFixed(2)
                                toFixed(
                                  +toFixed(
                                    +x.price *
                                      +x.amount *
                                      +onGetRate(x?.currency?.id),
                                    2
                                  ) *
                                    +toFixed(
                                      +(getIvaNumber(x?.ivaType) + '').replace(
                                        /\d\./,
                                        ''
                                      ) / 100,
                                      2
                                    ),
                                  2
                                )
                              )
                        }`}
                      </label>
                    </div>
                  </div>

                  <div style={{ width: '5%', marginRight: 5 }}>
                    <MdOutlineCancel
                      className="text-primary"
                      size={25}
                      onClick={() => {
                        let itemsCopy = [...items]
                        let newValue = itemsCopy.filter((_, i) => i !== idx)
                        setItems(newValue)
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {step === 1 && (
          <div className="grid grid-cols-2 gap-x-8 gap-y-4 mt-8">
            <div
              onClick={() => setTypeForm('cash')}
              className="bg-gray-200 p-[20px] flex justify-center items-center rounded-sm"
            >
              <label className="text-primary font-semibold">Efectivo</label>
            </div>

            <div
              onClick={() => setTypeForm('card')}
              className="bg-gray-200 p-[20px] flex justify-center items-center rounded-sm"
            >
              <label className="text-primary font-semibold">Tarjeta</label>
            </div>

            <div
              onClick={() => setTypeForm('transfer')}
              className="bg-gray-200 p-[20px] flex justify-center items-center rounded-sm"
            >
              <label className="text-primary font-semibold">
                Transferencia
              </label>
            </div>

            <div
              onClick={() => setTypeForm('mobilePayment')}
              className="bg-gray-200 p-[20px] flex justify-center items-center rounded-sm"
            >
              <label className="text-primary font-semibold">Pago móvil</label>
            </div>

            <div
              onClick={() => setTypeForm('onlinePayment')}
              className="bg-gray-200 p-[20px] flex justify-center items-center rounded-sm"
            >
              <label className="text-primary font-semibold text-center">
                Pago en linea (C2P)
              </label>
            </div>

            <div
              onClick={() => setTypeForm('zelle')}
              className="bg-gray-200 p-[20px] flex justify-center items-center rounded-sm"
            >
              <label className="text-primary font-semibold">Zelle</label>
            </div>
          </div>
        )}
      </div>

      <div
        className="overflow-y-auto"
        style={{ maxHeight: '10%', marginTop: '3%' }}
      >
        {selectedMethods.map((method, index) => (
          <div
            className="bg-gray-100 dark:bg-gray-800 rounded-lg mt-4 p-2 flex justify-between items-center"
            key={index}
          >
            <div className="flex">
              {/* {console.log("vuelto",)} */}
              {method.type} : {getDenomination(method?.currency?.id)}{' '}
              {formatPipe(toFixed(+method.amount, 2))}
            </div>
          </div>
        ))}
      </div>

      <div
        style={{ position: 'absolute', bottom: 60 }}
        ref={bottomRef}
        className="w-full"
      >
        <Divider />

        <div className="flex justify-between mt-5">
          <label className="text-sm">SUB TOTAL</label>
          <label className="text-sm font-semibold">
            {' '}
            Bs. {formatPipe(toFixed(sumOfValues('sub_total'), 2))}
          </label>
        </div>

        <div className="flex justify-between mt-2">
          <label className="text-sm">EXENTO</label>
          <label className="text-sm font-semibold">
            Bs. {formatPipe(toFixed(sumOfValues('exempt'), 2))}
          </label>
        </div>

        <div className="flex justify-between items-center mt-2">
          <div className="flex flex-row">
            <label className="text-sm mr-2">DESCUENTO</label>
            <Switch
              forForm={true}
              onChange={(value) => {
                setDiscountValue(0)
                setDisableDiscount(value)
                discountRef.current.value = '0'
              }}
            />
          </div>

          <input
            // min={0}
            type="text"
            className="cursor-text transition dark:bg-gray-600 dark:border-gray-600 dark:text-white h-inputDefault"
            disabled={!disableDiscount}
            ref={discountRef}
            style={{ width: '20%' }}
          />

          {/* <label className="text-sm font-semibold">Bs. 2.522,32</label> */}
        </div>

        <div className="flex justify-between">
          <div className="flex flex-row">
            <label className="text-sm mr-2">IGTF</label>
            <Switch
              value={isIGTFActive || igtfAmount > 0}
              forForm={true}
              onChange={(value) => {
                setIsIGTFActive(value)
                if (value) {
                  setIsIGTFActive(true)
                  // if (!alreadySelled) {
                  // setSelectedMethod({
                  //   name: 'IGTF',
                  //   icon: FaPercent,
                  //   accountType: accountTypeEnum.IGTF,
                  // })
                  // }
                } else {
                  setIgtfAmount(0)
                }
              }}
            />
          </div>
          <label className="text-sm font-semibold">
            Bs. {formatPipe(toFixed(igtfAmount, 2))}
          </label>
        </div>

        <div className="flex justify-between mt-2">
          <label className="text-sm">IVA</label>
          <label className="text-sm font-semibold">
            {' '}
            Bs. {formatPipe(toFixed(sumOfValues('iva'), 2))}
          </label>
        </div>

        <div className="flex justify-between mt-2">
          <label className="text-sm">TOTAL</label>
          <label className="text-sm font-semibold">
            Bs. {formatPipe(toFixed(getTotalAmount(), 2))}
          </label>
        </div>

        <div className="flex justify-between mt-2">
          <label className="text-sm">TOTAL EN USD (REF)</label>
          <label className="text-sm font-semibold">{`$${formatPipe(
            toFixed(getTotalAmount() / +onGetRate('1'), 2)
          )}`}</label>
        </div>

        <div className="flex flex-row justify-end">
          <Button
            type="primary"
            classes="w-1/2 mt-5"
            onClick={() => {
              if (step === 0) {
                setStep(1)
              }

              if (step === 1) {
                  onCreateSell()
              }
            }}
          >
            Continuar
          </Button>
        </div>
      </div>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={typeForm === 'cash'}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={typeForm === 'cash'}>
          <Box sx={style}>
            <CashForm
              rate={globalRate}
              debt={debt}
              onCancel={() => setTypeForm(null)}
              onSubmitProp={(values) => {
                console.log('CASH', values)
                onSelectMethod(values, accountTypeEnum.CASH)
              }}
            />
          </Box>
        </Fade>
      </ModalUI>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={typeForm === 'card'}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={typeForm === 'card'}>
          <Box sx={style}>
            <CardForm
              debt={debt}
              total={
                +toFixed(
                  getTotalAmount() -
                    +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                  2
                )
                // +(
                //   getTotalAmount() -
                //   +selectedMethods
                //     .reduce((a, b) => a + +b.amount, 0)
                //     .toFixed(2)
                // ).toFixed(2)
              }
              onCancel={() => setTypeForm(null)}
              onSubmitProp={(values) => {
                onSelectMethod(values, accountTypeEnum.CARD)
              }}
            />
          </Box>
        </Fade>
      </ModalUI>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={typeForm === 'zelle'}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={typeForm === 'zelle'}>
          <Box sx={style}>
            <ZellePaymentForm
              rate={globalRate}
              onSubmitProp={(v) => {
                onSelectMethod(v, accountTypeEnum.ZELLE)
              }}
              onCancel={() => setTypeForm(null)}
              total={
                +toFixed(
                  getTotalAmount() -
                    +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                  2
                )
                // +(
                //   getTotalAmount() -
                //   +selectedMethods
                //     .reduce((a, b) => a + +b.amount, 0)
                //     .toFixed(2)
                // ).toFixed(2)
              }
              debt={toFixed(
                getTotalAmount() -
                  +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                2
              )}
              // (
              //     getTotalAmount() -
              //     +selectedMethods.reduce((a, b) => a + +b.amount, 0)
              //   ).toFixed(2)
              // +(
              //   getTotalAmount() -
              //   +selectedMethods
              //     .reduce((a, b) => a + +b.amount, 0)
              //     .toFixed(2)
              // ).toFixed(2)
            />
          </Box>
        </Fade>
      </ModalUI>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={typeForm === 'transfer'}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={typeForm === 'transfer'}>
          <Box sx={style}>
            <TransferPaymentForm
              debt={debt}
              rate={globalRate}
              // total={
              //   +toFixed(getTotalAmount() -
              //     +selectedMethods
              //       .reduce((a, b) => a + +b.amount, 0), 2)
              //   // +(
              //   //   getTotalAmount() -
              //   //   +selectedMethods
              //   //     .reduce((a, b) => a + +b.amount, 0)
              //   //     .toFixed(2)
              //   // ).toFixed(2)
              // }
              onCancel={() => setTypeForm(null)}
              onSubmitProp={(values) => {
                onSelectMethod(values, values.type_account)
              }}
              options={[
                { text: 'Pago movil', value: 'mobilePayment' },
                { text: 'Transferencia Nacional', value: 'nationalTransfer' },
              ]}
            />
          </Box>
        </Fade>
      </ModalUI>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={typeForm === 'mobilePayment'}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={typeForm === 'mobilePayment'}>
          <Box sx={style}>
            <MobilePaymentForm
              debt={debt}
              rate={globalRate}
              total={
                +toFixed(
                  getTotalAmount() -
                    +selectedMethods.reduce((a, b) => a + +b.amount, 0),
                  2
                )
                // +(
                //   getTotalAmount() -
                //   +selectedMethods
                //     .reduce((a, b) => a + +b.amount, 0)
                //     .toFixed(2)
                // ).toFixed(2)
              }
              // total={
              //   +toFixed(getTotalAmount() -
              //     +selectedMethods
              //       .reduce((a, b) => a + +b.amount, 0), 2)
              //   // +(
              //   //   getTotalAmount() -
              //   //   +selectedMethods
              //   //     .reduce((a, b) => a + +b.amount, 0)
              //   //     .toFixed(2)
              //   // ).toFixed(2)
              // }
              onCancel={() => setTypeForm(null)}
              onSubmitProp={(values) => {
                onSelectMethod(values, accountTypeEnum.PAGO_MOVIL)
              }}
            />
          </Box>
        </Fade>
      </ModalUI>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={typeForm === 'onlinePayment'}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={typeForm === 'onlinePayment'}>
          <Box sx={style}>
            <OnlinePaymentForm
              debt={debt}
              rate={globalRate}
              // total={+toFixed(getTotalAmount() -
              //   +selectedMethods
              //     .reduce((a, b) => a + +b.amount, 0), 2)
              //   // +(
              //   //   getTotalAmount() -
              //   //   +selectedMethods
              //   //     .reduce((a, b) => a + +b.amount, 0)
              //   //     .toFixed(2)
              //   // ).toFixed(2)
              // }
              // total={
              //   +toFixed(getTotalAmount() -
              //     +selectedMethods
              //       .reduce((a, b) => a + +b.amount, 0), 2)
              //   // +(
              //   //   getTotalAmount() -
              //   //   +selectedMethods
              //   //     .reduce((a, b) => a + +b.amount, 0)
              //   //     .toFixed(2)
              //   // ).toFixed(2)
              // }
              onCancel={() => setTypeForm(null)}
              onSubmitProp={(values) => {
                onSelectMethod(values, accountTypeEnum.C2P)
              }}
            />
          </Box>
        </Fade>
      </ModalUI>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isIGTFActive}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={isIGTFActive}>
          <Box sx={style}>
            <IGTFForm
              onCancel={() => setIsIGTFActive(false)}
              onSubmit={(v) => {
                console.log('V', v)
                setIgtfAmount(v)
              }}
              rate={globalRate}
            />
          </Box>
        </Fade>
      </ModalUI>

      <ModalUI
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={c2pMode}
        onClose={() => {}}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={c2pMode}>
          <Box sx={style}>
          <div className='grid gap-3'>

<div className='col-span-12'>
  <div style={{backgroundColor: '#f6fbff', borderRadius: 10, padding: 10}} className='flex flex-row justify-between justify-items-center'>
    <label style={{color: '#70889e'}}>{`${window.location.origin}/pago_en_linea?id=${paymentId}`}</label>
    <Tooltip title="Copiar link">
    <MdOutlineFileCopy style={{color: '#70889e', cursor: 'pointer'}} onClick={async () => {
      try {
        await navigator.clipboard.writeText(`${window.location.origin}/pago_en_linea?id=${paymentId}`);
        addAlert({
              message: 'Link copiado satisfactoriamente',
              status: 'success',
            })
      } catch (error) {
        console.error('Falló al copiar el texto: ', error);
      }
    }} />
    </Tooltip>
  </div>
</div>

<div className='flex flex-col items-center col-span-12 mt-5'>
    <img src={qrCode} style={{height: 150, width: 150}} />

    <div>

      <div className='mt-3' style={{backgroundColor: '#dee7f3', padding: 10, borderRadius: 8}}>
        <label style={{color: '#2f7ee4', fontWeight: 900}}>{formatTime(seconds)}</label>
      </div>

    </div>

</div>

</div>
          </Box>
        </Fade>
      </ModalUI>

    </div>
  )
}

interface IMethods {
  name: string
  icon: IconType | null
  accountType: accountTypeEnum
}
